var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7229 1.27716C10.3533 0.907614 9.75473 0.907614 9.38521 1.27716L6.00029 4.66206L2.61537 1.27716C2.24585 0.907614 1.6471 0.907614 1.27757 1.27716C0.908052 1.64649 0.908052 2.24563 1.27757 2.61496L4.66206 5.99986L1.27714 9.38484C0.907619 9.7541 0.907619 10.353 1.27714 10.7226C1.46187 10.9075 1.70401 10.9999 1.946 10.9999C2.188 10.9999 2.43007 10.9075 2.61472 10.7226L6.00029 7.33745L9.38521 10.7229C9.56993 10.9077 9.81193 11 10.0539 11C10.2959 11 10.538 10.9077 10.7228 10.7229C11.0923 10.3535 11.0923 9.75438 10.7228 9.38506L7.33794 5.99986L10.7229 2.61496C11.0924 2.24563 11.0924 1.6467 10.7229 1.27716Z",
    fill: "#587E85",
    stroke: "#F3F3F3",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3e0f22f4d764c603f18a2fb88cb21b66.svg";
export { ForwardRef as ReactComponent };